import React, {useEffect, useState} from 'react';
import {useAccount} from 'wagmi';
import {GetBonusesService} from '../../api/get-bonuses-service';
import {contractABI} from '../../../../shared/api/contract/config';
import {ConnectorType, useAppKitProvider} from '@reown/appkit/react';
import styles from './Rewards.module.scss';
import Loader from '../../../../shared/ui/Loader/Loader';
import {GeneralSettings, Reward as RewardType, TDeposit} from '../../../../shared/api/contract';
import Reward from '../Reward/Reward';
import ShodawButton from '../../../../shared/ui/ShadowButton/ShodawButton';
import {MoonStaking} from '../../../../shared/api/contract/ethers/moon-staking';
import {ClaimService} from '../../api/claim-service';
import {message} from 'antd';
import {GetDepositsService} from "../../../deposit/api/get-deposits-service.ts";
import {formatDepositsToDepositsForServer} from "../../../../shared/utils/deposit.ts";
import {useTranslation} from "react-i18next";

export const Rewards = () => {
    const {address} = useAccount();
    const {walletProvider} = useAppKitProvider<ConnectorType>('eip155');
    const [pending, setPending] = useState(true);
    const [claiming, setClaiming] = useState(false);
    const [msg, setMsg] = useState('');
    const [generalSettings, setGeneralSettings] = useState<GeneralSettings>();

    const [deposits, setDeposits] = useState<TDeposit[]>([]);

    const [depositsIndexes, setDepositsIndexes] = useState<bigint[]>([]);
    const [mainreward, setMainReward] = useState(0);
    const depositService = address ? new GetDepositsService(import.meta.env.VITE_CONTARCT_ADDRESS, contractABI, walletProvider, address) : undefined;
    const rewardsService = address ? new GetBonusesService(import.meta.env.VITE_CONTARCT_ADDRESS, contractABI, walletProvider, address) : undefined;
    const moonStackingService = address ? new MoonStaking(import.meta.env.VITE_CONTARCT_ADDRESS, contractABI, walletProvider, address) : undefined;
    const claimService = address ? new ClaimService(import.meta.env.VITE_CONTARCT_ADDRESS, contractABI, walletProvider, address) : undefined;

    const {t} = useTranslation()

    useEffect(() => {
        if (!address || !moonStackingService || !pending || !depositService || !rewardsService) return;

        moonStackingService.getGeneralSettings().then((gs) => setGeneralSettings(gs));

        depositService.getDeposits(address, false)
            .then(([deposits, indexes]) => {
                setDeposits(deposits)
                setDepositsIndexes(indexes)
                rewardsService.getMainRewards(indexes)
                    .then(mainreward => setMainReward(Number(mainreward)))
                    .finally(() => setPending(false))

            })


    }, [address, pending]);

    useEffect(() => {
        if (pending || !address || !rewardsService || !depositService ) return;


        const intervalId = setInterval(() => {
            depositService.getDeposits(address, false)
                .then(([deposits, indexes]) => {
                    setDeposits(deposits)
                    setDepositsIndexes(indexes)
                    rewardsService.getMainRewards(indexes)
                        .then(mainreward => setMainReward(Number(mainreward)))
                        .finally(() => setPending(false))

                })

        }, 10_000)

        return () => clearInterval(intervalId);

    }, [pending, address]);

    async function claim() {
        if (!claimService || !depositService || !address || !generalSettings || !depositsIndexes.length) return;

        setClaiming(true);

        const claimingStatus = await claimService.claim(depositsIndexes, (msg) => setMsg(msg));

        if (claimingStatus === 'error') {
            setClaiming(false);
            // message.error('Не удалось вывести бонусы');
            return;
        }

        const depositsForServer = formatDepositsToDepositsForServer(deposits, address, Number(generalSettings.maxIterationsPerIndex))

        await claimService.saveRewards(depositsForServer);

        setClaiming(false);
        setPending(true);
    }

    return (
        <div className={styles.rewards}>
            {pending && <Loader/>}

            {!pending && (
                <>
                    {mainreward > 0 && (
                        <Reward
                            imgUri=""
                            symbol="MOON"
                            amount={mainreward}
                        />
                    )}

                    {
                        generalSettings &&
                        deposits.map(deposit => (
                            deposit.rewards.map((reward, index) => (
                                <Reward disable={index + 1 > Number(generalSettings.maxIterationsPerIndex)}
                                        key={Number(deposit.index) + Number(reward.amount)} {...reward}/>
                            ))
                        ))
                    }

                    {
                        mainreward === 0 && deposits.flatMap(deposit => deposit.rewards).length === 0 &&
                        <div className={styles.none}>
                            <p>{t('none_rewards')}</p>
                        </div>
                    }

                </>
            )}

            <ShodawButton
                onClick={async () => await claim()}
                disabled={pending || mainreward === 0 && deposits.flatMap(deposit => deposit.rewards).length === 0}
                title={t('get_rewards')}
            />

            {claiming && (
                <div className="shadow">
                    <Loader/>
                    <h1 dangerouslySetInnerHTML={{__html: msg}}></h1>
                </div>
            )}
        </div>
    );
};

// export default Rewards;